import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "ap-northeast-1_vFZZ9IZgb",
    ClientId: "1p17qbobg030h8h7pule7ic254"
}

export default new CognitoUserPool(poolData);